var exports = {
  "rb": "AccountRestrictionScreen.module__selectable___ak02dz",
  "wE": "AccountRestrictionScreen.module__directionScope___ak02dz",
  "v5": "AccountRestrictionScreen.module__dialogBody___ak02dz",
  "kL": "AccountRestrictionScreen.module__container___ak02dz",
  "MT": "AccountRestrictionScreen.module__surface___ak02dz",
  "qr": "AccountRestrictionScreen.module__footer___ak02dz",
  "DD": "AccountRestrictionScreen.module__title___ak02dz",
  "uW": "AccountRestrictionScreen.module__section___ak02dz",
  "R_": "AccountRestrictionScreen.module__heading___ak02dz",
  "z": "AccountRestrictionScreen.module__summary___ak02dz",
  "Qq": "AccountRestrictionScreen.module__text___ak02dz",
  "Cb": "AccountRestrictionScreen.module__fineText___ak02dz",
  "ir": "AccountRestrictionScreen.module__reference___ak02dz",
};

module.exports = exports;
